import React, { useEffect, useState } from 'react';
import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopBar from '../common/header/HeaderTopBar';
import AboutFour from '../elements/about/AboutFour';
import HomeTabOne from '../elements/advancetab/HomeTabOne';
import CounterUpFour from '../elements/counterup/CounterUpFour';
import CalltoActionFive from '../elements/calltoaction/CalltoActionFive';
import TeamFour from '../elements/team/TeamFour';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import FooterOne from '../common/footer/FooterOne';
import Copyright from '../common/footer/Copyright';
import ServiceOne from '../elements/service/ServiceOne';
import TestimonialOne from '../elements/testimonial/TestimonialOne';
import ContactForm from '../elements/contact/ContactForm';
import SectionTitleTwo from '../elements/sectionTitle/SectionTitleTwo';
import BlogList from '../components/blog/itemProp/BlogList';
import { fetchBlogPosts } from '../utils/blogApi';
import TimelineTwo from '../elements/timeline/TimelineTwo';
import BrandFour from '../elements/brand/BrandFour';
import Product from '../elements/service/Products';
import HeroSection from './HeroSection';
import { homePageSchemas, SITE_URL } from '../utils/structuredData';


const Home = () => {
    const [blogPosts, setBlogPosts] = useState([]);
    const [blogLoading, setBlogLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        (async () => {
            try {
                setBlogLoading(true);
                const { posts } = await fetchBlogPosts({ page: 1, limit: 3, status: 'published' });
                if (isMounted) {
                    if (Array.isArray(posts) && posts.length > 0) {
                        setBlogPosts(posts.slice(0, 3));
                    } else {
                        setBlogPosts([]);
                    }
                }
            } catch (e) {
                console.error('Error fetching blog posts:', e);
                if (isMounted) {
                    setBlogPosts([]);
                }
            } finally {
                if (isMounted) {
                    setBlogLoading(false);
                }
            }
        })();
        return () => { isMounted = false; };
    }, []);
    return (
        <>
            <SEO
                pageKey="home"
                title="Software Company in Tirunelveli | Custom Software & Mobile Apps — Jaz Infotech"
                description="Jaz Infotech is a software company in Tirunelveli specializing in custom software development, mobile app development, and web applications for businesses."
                keywords="software company Tirunelveli, custom software development Tirunelveli, mobile app development Tirunelveli, Jaz Infotech"
                canonical={SITE_URL + '/'}
                ogImage={`${SITE_URL}/images/logo/logo.png`}
                jsonLd={homePageSchemas()}
            />
            <main className="page-wrapper page-wrapper--home">
                {/* <HeaderTopBar /> */}
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                 {/* Start Hero Section Area  */}
                 <HeroSection />
                 {/* End Hero Section Area  */}

                


                <AboutFour image="./images/about/home-about-smart-it.png" />

             


                <Separator />
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "What We Build"
                                    title = "Custom Software & Mobile Apps"
                                    description = "We are a Tirunelveli-based software company helping businesses with custom software, mobile applications, and reliable web solutions. <a href='/software-company-tirunelveli'>Learn more about our software company in Tirunelveli</a>."
                                    />
                            </div>
                            
                            {/* "At Jaz Infotech, we turn ideas into powerful digital solutions — from smart web design to custom <br /> development — helping your business grow, perform, and succeed online with ease." */}
                        </div>


                        <ServiceOne 
                            serviceStyle = "service__style--1 icon-circle-style"
                            textAlign = "text-center"
                            />
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator />
                {/* Start Elements Area  */}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "Why Choose Us"
                                    title = "Your Software Partner in Tirunelveli"
                                    description = ""
                                />
                            </div>
                        </div>
                        <HomeTabOne />
                    </div>
                </div>
                {/* End Elements Area  */}


                <Separator />
                <div className="rwt-timeline-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Timeline"
                                        title = "How We Work."
                                        description = " We make the process simple from idea to launch, every step is focused on bringing your vision to life."
                                    />
                                    {/* At Jaz Infotech, we follow a clear, collaborative, and results-driven process to turn your ideas<br /> into powerful digital solutions. From planning to delivery, every step is focused on quality, transparency, and your success. */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1 mt--50">
                                <TimelineTwo classVar="dark-line"  />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="rwt-portfolio-area rn-section-gapBottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 mb--10">
                                <SectionTitleTwo
                                    Title= " Products"
                                    textAlign= "text-start"
                                />
                            </div>
                        </div>
                        <Product 
                            serviceStyle = "gallery-style"
                            textAlign = "text-start"
                        />
                    </div>
                </div>



                  {/* Start Brand Area  */}
                  <div className="rwt-brand-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Our Technologies Used"
                                        title = "Empowering Digital Growth."
                                        description = ""
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 mt--10">
                                    <BrandFour brandStyle="brand-style-2 variation-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Brand Area  */}
     
                {/* Temporarily Hidden - Client Feedback Section */}
                {false && (
                    <>
                        <Separator />
                        {/* Start Elements Area  */}
                        <div className="rwt-testimonial-area rn-section-gap">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 mb--10">
                                        <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            subtitle = "Client Feedback"
                                            title = "Awesome Clients Feedback."
                                            description = "Clients trust Jaz Infotech, Tirunelveli's leading IT company, for creative, responsive, and result-driven web solutions."
                                        />

                                        {/* Our clients trust Jaz Infotech for creative, responsive, and growth-focused web solutions. */}
                                    </div>
                                </div>
                                <TestimonialOne column="col-lg-4 col-md-6 col-12 mt--30" teamStyle="card-style-default testimonial-style-one" />
                            </div>
                        </div>
                        {/* End Elements Area  */}
                    </>
                )}

              {/* Start Elements Area  */}
              <div className="rwt-counterup-area rn-section-gapBottom mt_dec--30">
                    <div className="container">
                        <CounterUpFour column="col-lg-3 col-md-6 col-sm-6 col-12" counterStyle="counter-style-4" textALign="text-center" />   
                    </div>
                </div>
                {/* End Elements Area  */}
                <Separator />

                {!blogLoading && blogPosts.length > 0 && (
                    <div className="blog-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Latests News"
                                        title = "Our Latest News."
                                        description = "News and updates from our software development team."
                                    />
                                </div>
                            </div>
                            <div className="row row--15">
                                {blogPosts.map((item) => (
                                    <div key={item.id} className="col-lg-4 col-md-6 col-12 mt--30">
                                        <BlogList StyleVar="box-card-style-default" data={item} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                
                {!blogLoading && blogPosts.length === 0 && (
                    <div className="blog-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Latests News"
                                        title = "Our Latest News."
                                        description = "News and updates from our software development team."
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 text-center" style={{ padding: '40px 20px' }}>
                                    <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '10px' }}>
                                        No blog posts available at the moment.
                                    </p>
                                    <p style={{ color: '#878787', fontSize: '14px' }}>
                                        Check the browser console for debugging information.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )} 

                <Separator />


                <div className="contact-area rn-section-gapBottom">
                    <div className="container">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitleTwo
                                    Title= "Contact Us"
                                    textAlign= "text-start"
                                />
                            </div>
                        </div>
                        <div className="row row--30 mt--40 align-items-center">
                            <div className="col-lg-6">
                                <div className="home-contact-image">
                                    <img
                                        src="./images/about/home-contact-us.png"
                                        alt="Contact Jaz Infotech — custom software and mobile app development in Tirunelveli"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <ContactForm formStyle="contact-form-1" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Start Elements Area  */}
                {/* <div className="rwt-team-area rn-section-gap">
                    <div className="wrapper plr--65 plr_sm--15">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "Our Experts."
                                    title = "Our Experts"
                                    description = ""
                                />
                            </div>
                        </div>
                        <TeamFour column="col-lg-6 col-xl-3 col-md-6 col-12 mt--30" teamStyle="team-style-three" />
                    </div>
                </div> */}
                {/* End Elements Area  */}


                {/* Start Elements Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <CalltoActionFive />
                    </div>
                </div>
                {/* End Elements Area  */}

                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Home
